// Wires the redesign's email-capture forms (.email-form / .reset-form) to Klaviyo.
// Uses the client-side subscribe API (public company_id) so the custom design stays,
// and signups land in the existing funnel list (double opt-in handled by Klaviyo).
(function () {
  var COMPANY = 'UkQ4Sp';
  var LIST = 'SeJ59j'; // Ceremony Newsletter
  function wire(form) {
    if (form.dataset.kvWired) return;
    form.dataset.kvWired = '1';
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type=email]');
      if (!input) return;
      var email = input.value.trim();
      if (!email) return;
      var btn = form.querySelector('button');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending...'; }
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website redesign form',
              profile: { data: { type: 'profile', attributes: {
                email: email,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: LIST } } }
          }
        })
      }).then(function (r) {
        if (r.status === 202 || r.ok) {
          // Fire the Meta Pixel Lead event so website lead-gen campaigns can track + optimize
          try { if (window.fbq) { fbq('track', 'Lead', { content_name: '7-Day Hair Reset', content_category: 'lead-magnet' }); } } catch (e) {}
          form.innerHTML = '<p style="font-size:16px;color:var(--ocean);margin:0;font-weight:500">Almost there. Check your inbox and tap <b>confirm</b> to unlock your free 7-Day Reset and 15% off.</p>';
        } else {
          if (btn) { btn.disabled = false; btn.textContent = orig; }
          alert('Hmm, that did not go through. Please try again.');
        }
      }).catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = orig; }
        alert('Hmm, that did not go through. Please try again.');
      });
    });
  }
  document.querySelectorAll('.email-form, .reset-form').forEach(wire);
})();
